import Hero from "./Hero";
import Featured from "./Featured";
import About from "./About";
import Gallery from "./Gallery";

const Home = () => {
  return (
    <>
      <Hero />
      <Featured />
      <About />
      <Gallery />
    </>
  );
};

export default Home;
